import * as React from 'react';

import { useApi } from '../context';
import { NaicsCode } from '../models';
import { useDebounce, useNaicsCodeQuery } from '../hooks';
import { CerebroAutoComplete, CerebroAutoCompleteProps } from '.';

export const NaicsCodeAutoComplete: React.FC<NaicsCodeAutoCompleteProps> = props => {
	const api = useApi();

	const [inputValue, setInputValue] = React.useState('');

	const search = useDebounce(inputValue, 200);

	const enabled = inputValue != null && inputValue.length >= 3;

	const naicsCodesQuery = useNaicsCodeQuery();

	const options = enabled ? naicsCodesQuery.data ?? [] : [];

	return (
		<CerebroAutoComplete
			{...props}
			placeholder="6 Digit Naics Code"
			clearOnEscape
			loading={naicsCodesQuery.isFetching}
			options={options}
			isOptionEqualToValue={(option: NaicsCode, value: NaicsCode) => option.code === value.code}
			getOptionLabel={(naicsCode: NaicsCode) => `${naicsCode.code} - ${naicsCode.industryName}`}
			onInputChange={(_, newInputValue) => {
				setInputValue(newInputValue);
			}}
		/>
	);
};

type NaicsCodeAutoCompleteProps = CerebroAutoCompleteProps<NaicsCode, false, false, false>;
